import { createReducer } from 'redux-starter-kit';
import { putNormalizedInspection } from './inspectionActions';
import { selectVehicle } from '../vehicles/vehicleReducer';
import { selectOutcome } from '../outcomes/outcomeReducer';
import { selectInspectionReason } from '../inspectionReasons/inspectionReasonReducer';
import { selectInspectionDamage } from './inspectionDamageReducer';
import { selectInspectionNote } from '../inspectionNotes/inspectionNoteReducer';


/**
 * A selector for getting an inspection from the store.
 * @param {object} state The redux state of the application.
 * @param {number} inspectionId The id of the inspection.
 */
export const selectInspection = (state, inspectionId) => {
  const normalizedInspection = state.via.domain.inspections[inspectionId];
  if (!normalizedInspection) return normalizedInspection;

  // The inspection is stored normalised. So we need to rebuild the inspection from the ids.
  const inspection = { ...normalizedInspection };

  // Replace the vehicle id with a vehicle object.
  inspection.vehicle = normalizedInspection.vehicle ? selectVehicle(state, normalizedInspection.vehicle) : null;

  // Replace the inspection outcome code with the inspection outcome object.
  inspection.outcome = normalizedInspection.outcome ? selectOutcome(state, normalizedInspection.outcome) : null;

  // Replace the inspection reason with the inspection reason object.
  inspection.reason = normalizedInspection.reason ? selectInspectionReason(state, normalizedInspection.reason) : null;

  // Replace the existing damage ids with the damage objects.
  inspection.existingDamages = normalizedInspection.existingDamages
    ? normalizedInspection.existingDamages.map(id => selectInspectionDamage(state, id)).filter(damage => !!damage)
    : [];

  // Replace the new damage ids with the damage objects
  inspection.newDamages = normalizedInspection.newDamages
    ? normalizedInspection.newDamages.map(id => selectInspectionDamage(state, id)).filter(damage => !!damage)
    : [];

  // Replace the note ids with the note objects.
  inspection.notes = normalizedInspection.notes
    ? normalizedInspection.notes.map(noteId => selectInspectionNote(state, noteId))
    : [];

  // Replace the created-by user with the user object.
  inspection.createdBy = normalizedInspection.createdBy;

  return inspection;
};


const inspectionInitialState = {
  // inspectionCode: { /* inspection object */ }
  // inspectionCode: { /* inspection object */ }
  // ...etc
};

const inspectionReducer = createReducer(inspectionInitialState, {
  [putNormalizedInspection]: (state, action) => {
    const inspection = action.payload;
    return {
      ...state,
      [inspection.inspectionCode]: inspection,
    };
  },
});

export default inspectionReducer;
